module.exports = __webpack_public_path__ + "lp/img/send_icn-disabled.639cb788.svg";